import { IPISPurchaseInvoicePaymentPayload } from '@query'
import { omitEmptyValues } from './omitEmptyValues'

type PISPaymentOptions = {
  shortcutId?: number
  providerCode?: string
}

export const buildPISPurchaseInvoicePaymentPayload = (
  options: PISPaymentOptions | undefined,
  redirectUrl: string
): IPISPurchaseInvoicePaymentPayload => {
  return omitEmptyValues({
    shortcut_id: options?.shortcutId,
    provider_code: options?.providerCode,
    redirect_url: redirectUrl
  })
}
